import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import Button from '@salesforce/design-system-react/components/button';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import AgencyTransaction from '../../Shared/AgencyTransaction';

interface RequestId {
  requestId: string;
  isAgencyRecord: boolean;
}
// export interface Props extends RouteComponentProps
interface Props extends RouteComponentProps {
  item?: RequestId;
}

const OrderRequestId: FC<Props> = ({
  item = {
    requestId: null,
    isAgencyRecord: false,
  },
}) => {
  const { requestId, isAgencyRecord } = item;
  return (
    <DataTableCell title={requestId || ''}>
      <AgencyTransaction isAgencyRecord={isAgencyRecord} />
      <Button label={requestId || ''} variant="base" style={{ margin: '2px 2px 2px 2px' }} />
    </DataTableCell>
  );
};

export default withRouter(OrderRequestId);
